// Per-course status control (list cards, table rows and the editor form),
// coloured like the matching StatusBadge.

import { COURSE_STATUSES, type CourseStatus } from "../../types/course";

export function CourseStatusSelect({
  value,
  onChange,
  disabled,
  label,
  id,
}: {
  value: CourseStatus;
  onChange: (status: CourseStatus) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}) {
  return (
    <span className="co-status" onClick={(e) => e.stopPropagation()}>
      <select
        id={id}
        className={value}
        value={value}
        disabled={disabled}
        aria-label={label}
        onChange={(e) => onChange(e.target.value as CourseStatus)}
      >
        {COURSE_STATUSES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </span>
  );
}
